import { Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper from '@/services/helper';
import Q from 'q';
import api from '@/services/api';
import VueRecaptcha from 'vue-recaptcha';

import SendPasswordModal from '@/components/Modals/SendPasswordModal.vue';

@Component<HelpStatusMixins>({
  components: {
    SendPasswordModal,
  },
  computed: {
    ...mapState({
      Lang: 'Lang',
      ShowLanguages: 'ShowLanguages',
      CommitteeEmail: 'CommitteeEmail',
      CaptchaKey: 'CaptchaKey',
      ShowCaptcha: 'ShowCaptcha',
    }),
  },
})
export default class HelpStatusMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly Lang!: string;
  public readonly CommitteeEmail!: string;
  public readonly CaptchaKey!: string;
  public readonly ShowCaptcha!: boolean;

  public help: VoterIssue | null = null;
  public Message: string = '';
  public isLoading: boolean = false;

  @Prop()
  private tocken!: string;

  get emailLink() {
    return `<a href="mailto:${this.CommitteeEmail}">${this.CommitteeEmail}</a>`;
  }

  get StatusColor() {
    if (!this.help) return '';
    switch (this.help.Status) {
      case 'Open':
        return 'text-danger';
      case 'InProgress':
        return 'text-warning';
      case 'Closed':
        return 'text-success';
    }
    return '';
  }

  private updateId: number = 0;
  async mounted() {
    if (!this.tocken) {
      this.$router.replace({ name: 'Help' });
      return;
    }
    let loaded = await this.loadIssue(true);
    if (!loaded) {
      this.$router.replace({ name: 'Help' });
    }

    
    this.updateId = setInterval(() => {
      this.loadIssue();
    }, 60000);
  }
  async beforeDestroy() {
    clearInterval(this.updateId);
  }

  public async loadIssue(swalLoad: boolean = false) {
    this.isLoading = true;
    
    if(swalLoad) helper.swalShowLoading();
    var delay = Q.delay(500);
    let apiResult = await (await api.LoadIssue(this.tocken)).getData(true);
    if (!apiResult) {
      this.isLoading = false;
      return false;
    }
    await delay;
    this.isLoading = false;
    let hasMessages = this.help?.Messages?.length != apiResult.Data.Messages?.length;
    this.help = apiResult.Data;
    if(hasMessages){
      this.scrollMessages();
    }
    if(swalLoad) helper.close();
    return true;
  }

  async sendMessage() {
    if(!this.Message) return;

    helper.swalShowLoading();
    let apiResult = await (await api.SubmitIssueMessage(this.Message, this.tocken)).getData(true);
    if (!apiResult) {
      return false;
    }
    this.help = apiResult.Data;
    this.scrollMessages();
    helper.close();
    this.Message = '';
    return true;
  }

  scrollMessages(){
    this.$nextTick(async ()=>{
      await this.$nextTick();
      var el = this.$refs.messages as HTMLElement;
      if(!el) return;
      el.scrollTop = el.scrollHeight
    });
  }
}
